<template lang="pug">
    .assinatura-termo-compromisso-pessoa
        .content-slot
            .icon-check_sign.mdi.mdi-checkbox-marked
                .assinatura-header  <b>Informações da Assinatura: </b>             
            .assinatura-infos <b>Assinado por: </b>  {{ assinatura.nome }}
            .assinatura-infos <b>CPF: </b>{{ assinatura.cpfCpnj }}
            .assinatura-infos(:style="{ color: assinatura.dataAssinatura ? '' : 'red' }")  <b>Data Assinatura: </b> {{ getFormatedDate() }}            
    </template>

<script>
import moment from 'moment';
import { TipoAssinaturaEnum } from '@/enums/processo.enum.js';

export default {
    name: 'TermoCompromissoAssinaturaBoxComponent',

    props: {
        assinatura: Object,
    },

    components: {},

    data() {
        return {
            TipoAssinaturaEnum,
        };
    },

    methods: {
        getFormatedDate() {
            if (this.assinatura.dataAssinatura)
                return moment.utc(String(this.assinatura.dataAssinatura)).format('DD/MM/YYYY HH:mm:ss');
            return 'Assinatura pendente';
        },
        getTipoAssinatura(assinatura) {
            const idTipo = assinatura.idTipoAssinaturaTermo;
            const tiposAssinatura = {
                1: TipoAssinaturaEnum.GERENTE_OPERACIONAL.nome,
                2: TipoAssinaturaEnum.PROPRIETARIO_POSSUIDOR.nome,
                3: TipoAssinaturaEnum.COMPROMISSARIO.nome,
            };
            if (assinatura.cpfCpnj === '148.866.018-20' && idTipo === TipoAssinaturaEnum.GERENTE_OPERACIONAL.id) {
                return 'Técnico responsável pela SAA';
            } else {
                return tiposAssinatura[idTipo];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.assinatura-termo-compromisso-pessoa {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    padding: 5px;
    margin: 5px;
    width: 300px;

    font-size: 10px;

    .logo-slot {
        padding: 5px;

        .logo {
            width: 50px;
        }
    }

    .assinatura-infos {
        font-size: 12px;
        color: black;
    }

    .assinatura-header {
        font-size: 14px;
        color: black;
    }

    .content-slot {
        .b {
            font-weight: bolder;
        }

        .icon-check_sign {
            background-color: transparent;
            color: var(--primary-green);
            display: flex;
            align-items: center;
        }
    }
}
</style>
